import { WorksheetSettingsKey } from 'cadenza/workbook/model/worksheet-settings-key';
import { getWorksheetById, getWorksheets } from 'cadenza/workbook/workbook.state';
import { getSetting } from 'cadenza/workbook/workbook-settings-util';
import { theme } from 'cadenza/theming-api';

/**
 * Get the color of the worksheet, if available. (Without "auto"-calculation {@link getWorksheetBackgroundColor}.)
 *
 * @param {Worksheet} worksheet - the worksheet to get the color from
 * @return {string|null|undefined} - a hex color string if the worksheet it is available
 */
function getWorksheetBackgroundColorInternal(worksheet) {
  return getSetting(worksheet, WorksheetSettingsKey.toPersistenceKey('WORKSHEET_BACKGROUND_COLOR'));
}

/**
 * Get whether the color of the worksheet is set in auto-mode.
 *
 * @param {Worksheet} worksheet - the worksheet to get the color from
 * @return {boolean} - whether the color is set in auto-mode
 */
export function getWorksheetBackgroundColorAuto(worksheet) {
  return getWorksheetBackgroundColorInternal(worksheet) == null;
}

function getWorksheetViewBorders(worksheet) {
  return getSetting(worksheet, WorksheetSettingsKey.toPersistenceKey('WORKSHEET_VIEW_BORDERS'));
}

export function getWorksheetViewBordersAuto(worksheet) {
  return getWorksheetViewBorders(worksheet) == null;
}

export function calculateWorksheetViewBorders(id, state) {
  const viewBorders = getWorksheetViewBorders(getWorksheetById(state, id));
  if (viewBorders != null) {
    return viewBorders;
  }
  const worksheets = getWorksheets(state);
  const worksheetIndex = worksheets.map((worksheet) => worksheet.id).indexOf(id);
  const previousWorksheets = worksheets.slice(0, worksheetIndex);
  while (previousWorksheets.length > 0) {
    const borders = getWorksheetViewBorders(previousWorksheets.pop());
    if (borders != null) {
      return borders;
    }
  }
  return theme('workbook-view-border');
}

/**
 * Get the value of the visible setting of the worksheet.
 *
 * @param {WorksheetDto | Worksheet} worksheet - The worksheet to get the setting from.
 * @return {boolean} - True if the worksheet is visible, default: true.
 */
export function isWorksheetVisible(worksheet) {
  return getSetting(worksheet, WorksheetSettingsKey.toPersistenceKey('WORKSHEET_VISIBLE'), true);
}
